import React                   from 'react';
import { connect }              from 'react-redux';
import { Dispatch }             from "redux";
import { reducerType }          from 'reducer';
import { ActionTypes }          from 'actions/types';


import {
    DndContext,
    MouseSensor,
    TouchSensor,
    useSensor,
    useSensors
  }                              from '@dnd-kit/core';
import handleDragStart         from 'functions/drag/handleDragStart';
import handleDragEnd           from 'functions/drag/handleDragEnd';
import handleDragCancel        from 'functions/drag/handleDragCancel';
import DndQuestion             from './dndQuestion';
import InputQuestion           from './inputQuestion';
import Menu                    from 'components/menu';
import BigProgressBar          from 'components/progressBars/BigProgressBar';
import SmallProgressBar        from 'components/progressBars/ProgressBar';
import Pyrotechnics            from 'components/Pyrotechnics';
import OptionMenu              from 'components/OptionMenu';
import Modal                   from 'components/modal';
import Question                from './Question';
import makeTests               from 'functions/tests/makeTests';
import nextTest                from 'functions/tests/nextTest';
import nextLevel               from 'functions/tests/nextLevel';
import getQuestionVariant      from 'functions/tests/getQuestionVariant';
import getFeedBack             from 'functions/tests/getFeedBack';
import resetState              from 'functions/resetState';


import { makeStyles }          from "makeStyles";
import { componentsStateType, modalStateType } from 'reducer/types';

const useStyles = makeStyles()(
    (theme) => ({
        root : {
            position:       'fixed',
            left:           0,
            minHeight:      '100vh',
            maxHeight:      '100vh',
            display:        'flex',
            flexFlow:       'column',
            alignItems:     'center',
            transition:     'opacity 0.25s',
        },
        container: {
            width:          '100%',
            display:        'flex',
            alignItems:     'center',
        },
        feedBack: {
            minHeight: 30,
            fontSize:  20,
            color:     theme.darkBlue
        },
        pyrotechnics: {
            position:        'fixed',
            width:           '100vw',
            height:          '100vh',
            top:             0,
            left:            0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            transition:      'all 1s',
            zIndex:          2
        }
    }),
);

type TirgulPropsType = {
    size:            number[];
    menuSize:        number;
    wideScreen:      boolean;
    componentsState: componentsStateType;
    modalState:      modalStateType;
}

const Tirgul: React.FC<TirgulPropsType> = ({ 
    size, 
    menuSize,
    wideScreen,
    componentsState,
    modalState
}) => {

    const { classes } = useStyles();
    const sensors     = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));

    const [tests, setTests]     = React.useState([] as number[][]);
    const [level, setLevel]     = React.useState(0);
    const [testNum, setTestNum] = React.useState(0);

    React.useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            const testArr = makeTests();
            setTests(testArr);
        }
        return () => { unmounted = true };
    },[])


    const goToNextTest = () => {
        nextTest(testNum, level, tests, setTestNum, setLevel)
    }

    const goToNextLevel = () => {
        nextLevel(level, setTestNum, setLevel)
    }

    const reset = () => {
        const testArr = makeTests();
        setTests(testArr);
        setLevel(0)
        setTestNum(0)
        resetState();
    }

    const [question, questionVariant] = React.useMemo(() => {
        const { q_, qvar } = getQuestionVariant(tests, level, testNum)
        return [q_, qvar]
    },[tests, level, testNum])
    

  const [shake, setShake] = React.useState(false)
  const [fail, setFail]   = React.useState(componentsState.failurCount)

  React.useEffect(() => {
    if (componentsState.failurCount > 0 && componentsState.failurCount !== fail) {
        setFail(componentsState.failurCount)
        setShake(true)
        setTimeout(() => {
            setShake(false)
        },500)
    }
  },[componentsState, fail])


    const feedBack = React.useMemo(() => {
       return componentsState.hideFeedBack ? '' : getFeedBack();
    },[componentsState])


    const [rootStyle, containerStyle] = React.useMemo(() => {
        return[
            { 
               width:          size[0] - menuSize,
               opacity:        componentsState.animateComp ? 0 : 1,
               justifyContent: wideScreen ? (questionVariant === 'input' ? 'flex-end' : 'center') : 'space-evenly',
            },
            {
               flexFlow:       wideScreen ? 'row' : 'column',
               justifyContent: wideScreen ? 'center' : 'space-between',
               flex:           wideScreen ? 0.4 : 0.2,
            }
        ]
     },[size, menuSize, wideScreen, componentsState, questionVariant])


    return(
      <>
        {
            !!tests.length && wideScreen &&
            <BigProgressBar
               size     = { size }     
               menuSize = { menuSize } 
               length   = { tests[level].length - 1 }   
               prog     = { testNum }     
            />
        }
        {
            !!tests.length && !wideScreen &&
            <SmallProgressBar
               length   = { tests[level].length - 1 }   
               testNum  = { testNum }     
            />
        }
        <div 
           className = { classes.root }
           style     = { rootStyle }
        >
            {
                !!tests.length &&
                <>
                   <Question
                       size       = { size }
                       question   = { question }
                       variant    = { questionVariant }
                       wideScreen = { wideScreen }
                   />
                    <div 
                       className = { classes.container }
                       style     = { containerStyle }
                    >
                           <DndContext 
                              sensors      = { sensors }
                              onDragStart  = { handleDragStart } 
                              onDragEnd    = { handleDragEnd }
                              onDragCancel = { handleDragCancel }
                            >
                            {
                            questionVariant === 'dnd' &&
                               <DndQuestion 
                                  size         = { size }
                                  wideScreen   = { wideScreen }
                                  feedBack     = { feedBack }
                                  shake        = { shake }
                                  question     = { !!tests.length ? tests[level][testNum] : -1 }
                                  lastTest     = { level === 2 && testNum >= tests[2].length - 1 }
                                  goToNextTest = { goToNextTest }
                               />
                            }
                            </DndContext>
                        {
                            questionVariant === 'input' &&
                            <InputQuestion
                               question     = { !!tests.length ? tests[level][testNum] : -1 }
                               feedBack     = { feedBack }
                               shake        = { shake }
                               lastTest     = { level === 2 && testNum >= tests[2].length - 1 }
                               goToNextTest = { goToNextTest }
                            />
                        }
                    </div>
                </>
            }
        </div>
        <Menu
          level         = { level }
          menuSize      = { menuSize } 
          wideScreen    = { wideScreen }
          goToNextTest  = { goToNextTest }
          goToNextLevel = { goToNextLevel }
        />
        {
           componentsState.showPyrotechnics
           &&
           <div
               className = { classes.pyrotechnics }
               >
                  {
                    Array(20).fill(0).map((val, ind) => {
                      return(
                        <div key = { `pyrotechics_exercises${ ind }` }>
                            <Pyrotechnics
                              size = { size }
                              num  = { Math.round(Math.random() * 6) }
                            />
                        </div>
                      )
                    })
               }
           </div>
        }
        <OptionMenu 
           showOptionMenu = { componentsState.showPyrotechnics }
           reset          = { reset }
        />
        {
          modalState.showModal &&
          <Modal 
            size     = { size }
            question = { question }
          />
        }
      </>
    )
}


  

const mapStateToProps = (reducer: reducerType) => {
  return {
    componentsState: reducer.components,
    modalState:      reducer.modal
}};
  
const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
});
  
export default connect(mapStateToProps,mapDispatchToProps)(Tirgul);
  
  
  
  
  
  